import { useContext } from 'react';
import { MilitaryChartsDataContext } from '../contexts/MilitaryChartsDataContext';

export const useMilitaryChartsDataContext = () => {
    return useContext(MilitaryChartsDataContext);
};
